import AdminAiScanReview from "../components/ai-scans/AdminAiScanReview";
import { useAdminAiScanReports } from "../hooks/useAdminAiScanReports";

// Reads resilience reports only while this page is mounted.
// Keeps the actor, repeatable backend cost and observed protections together when reviewing pressure risks.
// Coverage gaps remain separate from findings because an unverified control is not proof of a completed review.
const AdminAiResilienceScanPage = () => {
  const { reports, featureReports, issues, loading, error, refresh, available } = useAdminAiScanReports("resilience");

  return (
    <AdminAiScanReview
      scan="resilience"
      title="Resilience"
      description="Review availability, rate-limit and repeated-cost risks by module, business object, surface and feature. Follow who can trigger each path, the work it causes and the expected versus observed protections. Load formulas and attack scenarios retain their original notation; finding severity remains separate from review coverage."
      featureReviewKey="featureResilience"
      findingFields={[
        "exposure",
        "actor",
        "routeOrMethod",
        "rateLimitAction",
        "expectedLimit",
        "observedLimit",
        "costSurface",
        "loadFormula",
        "attackScenario",
        "explanation",
        "filePath",
        "line",
        "symbol",
        "remediation",
        "affectedFeatureIds",
        "canonicalKey",
      ]}
      reports={reports}
      featureReports={featureReports}
      issues={issues}
      loading={loading}
      error={error}
      available={available}
      onRefresh={refresh}
    />
  );
};

export default AdminAiResilienceScanPage;
